import React from 'react';
import {
  isWarehouseOrder,
  productThumb,
  WAREHOUSE_ORDER_BADGE_LABEL,
} from '../utils/warehouseUi';

const BADGE_STYLE = {
  backgroundColor: '#0F766E',
  color: '#fff',
  border: 'none',
};

export function WarehouseOrderBadge({ order }) {
  if (!isWarehouseOrder(order)) return null;
  return (
    <span className="vi-badge vi-badge--compact" style={BADGE_STYLE} title="طلب من المستودع">
      {WAREHOUSE_ORDER_BADGE_LABEL}
    </span>
  );
}

function itemQty(item) {
  return Number(item?.quantity ?? item?.qty) || 0;
}

function itemPrice(item) {
  return Number(item?.price ?? item?.selling_price) || 0;
}

export default function WarehouseOrderItems({ order, currencySymbol = '' }) {
  if (!isWarehouseOrder(order)) return null;
  const items = Array.isArray(order?.items) ? order.items : [];
  const warehouseLabel = [order.warehouse_name, order.warehouse_code].filter(Boolean).join(' · ');
  const handling = Number(order.handling_fee);
  const showHandling = Number.isFinite(handling) && handling > 0;

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {warehouseLabel ? (
        <div className="vi-form-locked" style={{ fontSize: 13 }}>
          المستودع: {warehouseLabel}
        </div>
      ) : null}
      {showHandling ? (
        <div className="vi-form-locked" style={{ fontSize: 13 }}>
          رسوم التجهيز: {handling.toFixed(2)}{currencySymbol ? ` ${currencySymbol}` : ''}
        </div>
      ) : null}
      {items.length === 0 ? (
        <p className="vi-dashboard-empty" style={{ margin: 0 }}>لا توجد أصناف مسجّلة</p>
      ) : (
        items.map((item) => {
          const thumb = productThumb(item.images);
          return (
            <div
              key={item.id || `${item.warehouse_product_id}-${item.name}`}
              style={{
                display: 'flex',
                gap: 12,
                alignItems: 'center',
                padding: '8px 10px',
                border: '1px solid var(--color-border, #eee)',
                borderRadius: 10,
                background: 'var(--color-surface, #fff)',
              }}
            >
              {thumb ? (
                <img
                  src={thumb}
                  alt={item.name || 'صورة المنتج'}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: 'cover',
                    borderRadius: 8,
                    flexShrink: 0,
                    background: '#f3f3f3',
                  }}
                />
              ) : (
                <div
                  aria-hidden
                  style={{
                    width: 48,
                    height: 48,
                    borderRadius: 8,
                    flexShrink: 0,
                    background: '#F1F5F4',
                    color: '#0F766E',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 18,
                  }}
                >
                  📦
                </div>
              )}
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{item.name || '—'}</div>
                <div style={{ fontSize: 12, color: 'var(--color-text-muted, #888)', marginTop: 2 }}>
                  {item.barcode ? <span dir="ltr">{item.barcode}</span> : 'بدون باركود'}
                  {item.sku ? ` · SKU ${item.sku}` : ''}
                  {` · × ${itemQty(item)}`}
                  {itemPrice(item) ? ` · ${itemPrice(item).toFixed(2)}` : ''}
                </div>
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
